'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2; /* eslint-disable */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactTable = require('react-table');

var _reactTable2 = _interopRequireDefault(_reactTable);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

require('react-table/react-table.css');

var _reactCsv = require('react-csv');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * SearchUsers, panel which admin has access to upon
 * login, this panel enables the admin to obtain
 * important information about all users using Reboot
 * Kids
 * https://github.com/react-tools/react-table
 */
var AdminUsers = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user, user_ids: state.admin.user_ids };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(AdminUsers, _Component);

  function AdminUsers() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AdminUsers);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AdminUsers.__proto__ || (0, _getPrototypeOf2.default)(AdminUsers)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      // columns for the table
      columns: [],
      filteredData: []
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AdminUsers, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var columns = this.props.user_ids[0];
      var key = '';
      var obj = this.state;

      // iterating through the first item in the
      // array of objects will give us the columns
      for (key in columns) {
        if (columns.hasOwnProperty(key)) {
          obj.columns.push({ 'Header': key, 'accessor': key });
        }
      }
      obj.filteredData = this.props.user_ids;
      this.state = obj;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Admin.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Row,
          null,
          _react2.default.createElement(
            ReactBootstrap.Col,
            { md: 12 },
            _react2.default.createElement(
              'h1',
              null,
              'Users'
            ),
            _react2.default.createElement(_reactTable2.default, { data: this.props.user_ids, columns: this.state.columns, filterable: true, defaultPageSize: 15,
              pageSizeOptions: [5, 10, 15, 20, 25, 50, 100],
              ref: function ref(el) {
                _this2.tableInstance = el;
              },
              onFilteredChange: function onFilteredChange() {
                var key = '';
                var obj = _this2.state;
                obj.filteredData = [];
                var map = _this2.tableInstance.getResolvedState().sortedData;
                for (key in map) {
                  if (map.hasOwnProperty(key)) {
                    obj.filteredData.push(map[key]._original);
                  }
                }
                _this2.setState(obj);
              },
              defaultFilterMethod: function defaultFilterMethod(filter, row) {
                return String(row[filter.id]).includes(filter.value);
              } })
          )
        ),
        _react2.default.createElement('div', { className: styles.spacer20 }),
        _react2.default.createElement(
          _reactCsv.CSVLink,
          { filename: "user-ids.csv", data: this.state.filteredData,
            target: '_blank' },
          _react2.default.createElement(
            ReactBootstrap.Button,
            { className: 'btn btn-success' },
            'Export as CSV'
          )
        ),
        _react2.default.createElement('div', { className: styles.spacer40 })
      );
    }
  }]);
  return AdminUsers;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  user_ids: _propTypes2.default.array
}, _temp2)) || _class);
/* eslint-enable */

exports.default = AdminUsers;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Admin/AdminUsers.js
// module id = 1149
// module chunks = 0